module.exports = __webpack_public_path__ + "static/media/moto.ed1d9358.png";